"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uimap = void 0;
exports.uimap = {
  admin: {
    main: {
      menu: {
        products: {
          allProducts: {},
          seasons: {},
          categories: {},
          options: {}
        },
        invoices: {
          allInvoices: {},
          payments: {},
          refunds: {}
        },
        discounts: {},
        participants: {},
        delivery: {
          shipments: {},
          operators: {},
          deliveryMethods: {},
          products: {},
          rates: {}
        },
        reports: {
          taxReport: {}
        },
        admin: {
          paymentProviders: {},
          legalEntities: {},
          taxRates: {},
          formBuilder: {},
          formScenarios: {},
          economicUnion: {},
          countries: {}
        }
      },
      pages: {
        countries: {
          list: {
            table: {},
            editButton: {}
          }
        },
        home: {},
        products: {
          allProducts: {
            list: {
              table: {},
              createButton: {},
              changeStatus: {},
              editButton: {}
            },
            createEdit: {}
          },
          seasons: {
            list: {
              table: {},
              viewSwitch: {},
              createButton: {},
              editButton: {},
              deleteButton: {},
              changeStatus: {}
            },
            createEdit: {}
          },
          categories: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          options: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          }
        },
        invoices: {
          allInvoices: {
            list: {
              table: {},
              createButton: {},
              copyToClipboardButton: {},
              followLinkButton: {},
              editButton: {},
              refundButton: {},
              deleteButton: {},
              addPaymentButton: {},
              viewAccountButton: {},
              exportToXlsButton: {},
              exportToCsvButton: {},
              salesReportButton: {}
            },
            createEdit: {},
            bankPayment: {
              addBankPayment: {},
              confirmBankPayment: {}
            },
            salesReport: {}
          },
          payments: {},
          refunds: {
            list: {
              table: {},
              editButton: {},
              deleteButton: {},
              deniedButton: {},
              sendToPaymentProviderButton: {}
            },
            createEdit: {}
          }
        },
        discounts: {
          list: {
            table: {},
            createButton: {},
            editButton: {},
            deleteButton: {},
            deleteAllButton: {}
          },
          createEdit: {}
        },
        participants: {
          list: {}
        },
        delivery: {
          shipments: {
            list: {}
          },
          operators: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          products: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          deliveryMethods: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          rates: {
            list: {
              table: {},
              createButton: {},
              uploadCSVButton: {},
              deleteAllButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          }
        },
        reports: {
          taxReport: {}
        },
        admin: {
          paymentProviders: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          legalEntities: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          taxRates: {
            list: {
              table: {},
              createButton: {},
              historyButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {},
            viewHistory: {}
          },
          formBuilder: {
            list: {
              table: {},
              createButton: {},
              isPublicSwitch: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          formScenarios: {
            list: {
              table: {},
              createButton: {},
              link: {},
              waitingListButton: {},
              activeSwitch: {},
              editButton: {},
              deleteButton: {}
            },
            waitingList: {},
            createEdit: {}
          },
          economicUnion: {
            list: {
              table: {},
              createButton: {},
              editButton: {},
              deleteButton: {}
            },
            createEdit: {}
          },
          customFields: {
            list: {}
          }
        }
      }
    },
    signIn: {
      page: {}
    }
  },
  user: {
    pay: {
      invoice: {
        pay: {
          invoicePay: {}
        },
        receipt: {
          invoiceReceipt: {}
        },
        scenarios: {
          scenarioDispatch: {}
        }
      }
    }
  }
};